import { PageBuilderWidgetModel, PageBuilderColumnPropertiesModel } from "@de-trustleap/shared-models";
import { createElementFromWidget } from '../render/createElementFromWidget';
import { BaseWidget } from './baseWidget';
import { mapMainAxisAlignment, mapCrossAxisAlignment } from '../utils/axisAlignmentUtils';

export class ColumnWidget extends BaseWidget<PageBuilderColumnPropertiesModel> {
    private children: PageBuilderWidgetModel[];
    private maxWidth?: number;

    constructor(children: PageBuilderWidgetModel[], maxWidth?: number, properties?: PageBuilderColumnPropertiesModel) {
        super(properties || {} as PageBuilderColumnPropertiesModel);
        this.children = children;
        this.maxWidth = maxWidth;
    }

    async render(): Promise<HTMLElement> {
        const element = document.createElement('div');
        element.classList.add('column-widget');

        this.applyStyles(element, {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            boxSizing: 'border-box',
            justifyContent: mapMainAxisAlignment(this.properties?.mainAxisAlignment),
            alignItems: mapCrossAxisAlignment(this.properties?.crossAxisAlignment),
            maxWidth: this.maxWidth ? `${this.maxWidth}px` : 'none',
            margin: this.maxWidth ? '0 auto' : '0'
        });

        for (const child of this.children) {
            const childElement = await createElementFromWidget(child);
            if (childElement) {
                if (child.widthPercentage) {
                    childElement.style.width = `${child.widthPercentage}%`;
                }
                element.appendChild(childElement);
            }
        }

        return element;
    }
}